"use client";

import { c as _c } from "react/compiler-runtime";
import { PredictBlockNumbersResponseApiModel } from "@/app/tools/block-finder/page.client";
import AllowlistToolCommonModalWrapper, { AllowlistToolModalSize } from "@/components/allowlist-tool/common/modals/AllowlistToolCommonModalWrapper";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import BlockPickerResultTableRowModal from "./BlockPickerResultTableRowModal";
export default function BlockPickerResultTableRow(t0) {
  const $ = _c(25);
  const {
    predictedBlock
  } = t0;
  const [showModal, setShowModal] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowModal(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `tw-group hover:tw-bg-iron-800/60 tw-transition tw-duration-300 tw-ease-out ${showModal ? "" : "tw-cursor-pointer"}`;
  let t3;
  if ($[1] !== predictedBlock.blockNumberIncludes) {
    t3 = <td className="tw-align-baseline tw-w-px tw-whitespace-nowrap tw-py-3 tw-px-4 tw-text-sm tw-font-medium tw-text-white tw-text-center">{predictedBlock.blockNumberIncludes}</td>;
    $[1] = predictedBlock.blockNumberIncludes;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== predictedBlock.count) {
    t4 = <td className="tw-align-baseline tw-w-px tw-whitespace-nowrap tw-py-3 tw-px-4 tw-text-sm tw-font-medium tw-text-white tw-text-center">{predictedBlock.count}</td>;
    $[3] = predictedBlock.count;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== predictedBlock.blockNumbers) {
    t5 = predictedBlock.blockNumbers.join(", ");
    $[5] = predictedBlock.blockNumbers;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <td className="tw-w-full tw-whitespace-normal tw-break-words tw-py-3 tw-px-4 tw-text-sm tw-font-medium tw-text-white tw-text-left">{t5}</td>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <td className="tw-align-baseline tw-w-[28px] tw-whitespace-nowrap tw-py-3 tw-px-4 tw-text-center"><FontAwesomeIcon icon={faMagnifyingGlass} height={18} /></td>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t6) {
    t8 = <tr onClick={t1} className={t2}>{t3}{t4}{t6}{t7}</tr>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setShowModal(false);
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `Block includes: ${predictedBlock.blockNumberIncludes}`;
  let t11;
  if ($[16] !== predictedBlock) {
    t11 = <BlockPickerResultTableRowModal predictedBlock={predictedBlock} />;
    $[16] = predictedBlock;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== showModal || $[19] !== t10 || $[20] !== t11) {
    t12 = <AllowlistToolCommonModalWrapper showModal={showModal} onClose={t9} title={t10} modalSize={AllowlistToolModalSize.X_LARGE} showTitle={false}>{t11}</AllowlistToolCommonModalWrapper>;
    $[18] = showModal;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t8) {
    t13 = <>{t8}{t12}</>;
    $[22] = t12;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}